/**
 * @description router全局配置，如有必要可分文件抽离，其中asyncRoutes只有在intelligence模式下才会用到，pro版只支持remixIcon图标，具体配置请查看vip群文档
 */

import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import Layout from '@/vab/layouts'
import { authentication, isHashRouterMode, publicPath } from '@/config'

export const constantRoutes = [
  {
    path: '/operations-connect',
    name: 'OperationsConnect',
    component: () => import('@/views/operationsConnect'),
    meta: { hidden: true, title: '运营与监控' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/register',
    name: 'Register',
    component: () => import('@/views/register'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/callback',
    name: 'Callback',
    component: () => import('@/views/callback'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/403',
    name: '403',
    component: () => import('@/views/403'),
    meta: {
      hidden: true,
    },
  },
  {
    path: '/404',
    name: '404',
    component: () => import('@/views/404'),
    meta: {
      hidden: true,
    },
  },
]

export const asyncRoutes = []

export const hiddenRoutes = [
  {
    path: '/exhibitionManage',
    component: Layout,
    redirect: '/exhibitionManage/aiVideoScript',
    meta: {
      hidden: true,
    },
    children: [
      {
        path: 'aiVideoScript',
        name: 'AiVideoScript',
        component: () => import('@/views/exhibitionManage/aiVideoScript.vue'),
        meta: {
          title: 'AI 视频工作台',
          hidden: true,
          activeMenu: '/exhibitionManage/meetingManage',
        },
      },
      {
        path: 'meetingTranscript',
        name: 'MeetingTranscript',
        component: () => import('@/views/exhibitionManage/meetingTranscript.vue'),
        meta: { title: '原声逐字播放', hidden: true, activeMenu: '/exhibitionManage/meetingManage' },
      },
      {
        path: 'appManage',
        name: 'AppManage',
        component: () => import('@/views/exhibitionManage/appManage.vue'),
        meta: {
          title: '应用管理',
          hidden: true,
          activeMenu: '/exhibitionManage',
        },
      },
      {
        path: 'meetingAppManage',
        name: 'MeetingAppManage',
        component: () => import('@/views/exhibitionManage/meetingAppManage.vue'),
        meta: {
          title: '会议管理',
          hidden: true,
          activeMenu: '/exhibitionManage/meetingManage',
        },
      },
      {
        path: 'meetingSubscription',
        name: 'MeetingSubscription',
        component: () => import('@/views/exhibitionManage/meetingSubscription.vue'),
        meta: { title: '报名结果订阅', hidden: true, activeMenu: '/exhibitionManage/meetingManage' },
      },
      {
        path: 'meetingContent',
        name: 'MeetingContent',
        component: () => import('@/views/exhibitionManage/meetingContent.vue'),
        meta: {
          title: '会议内容编辑',
          hidden: true,
          activeMenu: '/exhibitionManage/meetingManage',
        },
      },
    ],
  },
]

const router = createRouter({
  history: isHashRouterMode ? createWebHashHistory(publicPath) : createWebHistory(publicPath),
  routes: constantRoutes,
})

function fatteningRoutes(routes) {
  return routes.flatMap((route) => {
    return route.children ? fatteningRoutes(route.children) : route
  })
}

function addRouter(routes) {
  routes.forEach((route) => {
    console.log(route)
    if (route.children) route.name += '-layout'
    if (!router.hasRoute(route.name)) router.addRoute(route)
    if (route.children) addRouter(route.children)
  })
}

export function resetRouter(routes = constantRoutes) {
  routes.map((route) => {
    if (route.children) {
      route.children = fatteningRoutes(route.children)
    }
  })
  router.getRoutes().forEach((route) => {
    const routeName = route.name
    router.hasRoute(routeName) && router.removeRoute(routeName)
  })
  addRouter(routes)
}

export function setupRouter(app) {
  if (authentication === 'intelligence') addRouter(asyncRoutes)
  app.use(router)
  return router
}

export default router
